var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.911,
    height: 27.667,
    viewBox: "0 0 22.911 27.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "certificate",
    transform: "translate(-44.011 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15514",
    "data-name": "Path 15514",
    d: "M63.031,11.512V1.877A1.88,1.88,0,0,0,61.154,0H45.888a1.88,1.88,0,0,0-1.877,1.877V21.9a1.88,1.88,0,0,0,1.877,1.877H57.412V26.8a.865.865,0,0,0,1.293.751l2.6-1.484c2.868,1.639,2.718,1.6,3.026,1.6a.865.865,0,0,0,.865-.865V20.91A5.621,5.621,0,0,0,63.031,11.512ZM45.888,22.046a.148.148,0,0,1-.148-.148V1.877a.148.148,0,0,1,.148-.148H61.154a.148.148,0,0,1,.148.148v9.362a5.617,5.617,0,0,0-3.891,9.671v1.136Zm17.575,3.265-1.732-.99a.865.865,0,0,0-.858,0l-1.732.99V22.046a5.614,5.614,0,0,0,4.323,0v3.266ZM61.3,20.749a3.891,3.891,0,1,1,3.891-3.891A3.895,3.895,0,0,1,61.3,20.749Z",
    fill: "#d34a7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15515",
    "data-name": "Path 15515",
    d: "M318.17,277.321c-.338,0-.381-.08-1.776-1.01a.865.865,0,1,1,.959-1.439l.578.385,1.25-1.874a.865.865,0,1,1,1.439.959l-1.729,2.594A.864.864,0,0,1,318.17,277.321Z",
    transform: "translate(-257.301 -258.247)",
    fill: "#d34a7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15516",
    "data-name": "Path 15516",
    d: "M132.224,81.729h-7.349a.865.865,0,1,1,0-1.729h7.349a.865.865,0,1,1,0,1.729Z",
    transform: "translate(-75.677 -75.677)",
    fill: "#d34a7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15517",
    "data-name": "Path 15517",
    d: "M132.224,145.729h-7.349a.865.865,0,1,1,0-1.729h7.349a.865.865,0,0,1,0,1.729Z",
    transform: "translate(-75.677 -136.219)",
    fill: "#d34a7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15518",
    "data-name": "Path 15518",
    d: "M129.2,209.729h-4.323a.865.865,0,1,1,0-1.729H129.2a.865.865,0,1,1,0,1.729Z",
    transform: "translate(-75.677 -196.761)",
    fill: "#d34a7c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.ed03d01cddcd0f02417786ae87a9fd97.svg";
export { ForwardRef as ReactComponent };